import { createFilterStore } from './createFilterStore';

export const usePayslipFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  status: '',
  employeeId: '',
  periodMonth: '',
  periodYear: '',
  sortBy: 'createdAt',
  sortOrder: 'desc' as const,
});
